import { AxiosInstance } from 'axios';

/**
 * An environment's board of Exact's limits: the newest day and minute that anything asking Exact with the
 * connector's token was told - the connector's apps, the scenario runner, the dashboard. Mirrors ExactLimitsBoardDto.
 */
export interface ExactLimitsBoard {
    readAtUtc: string;
    dailyLimit?: number | null;
    dailyRemaining?: number | null;
    dailyResetsAtUtc?: string | null;
    dailyReadAtUtc?: string | null;
    dailySource?: string | null;
    minutelyLimit?: number | null;
    minutelyRemaining?: number | null;
    minutelyResetsAtUtc?: string | null;
    minutelyReadAtUtc?: string | null;
    minutelySource?: string | null;
    simulatedDailyUntilUtc?: string | null;
    error?: string | null;
}

/** Reads the board of one environment: a single point read, meant to be asked every few seconds. */
export const getExactLimitsBoard = async (
    axios: AxiosInstance,
    customer: string,
    environment: string
): Promise<ExactLimitsBoard> => {
    const response = await axios.get(
        `/Exact/${encodeURIComponent(customer)}/${encodeURIComponent(environment)}/limits`
    );

    // The axios instance is created with transformResponse: [], so response.data is a string.
    return typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
};
